import React, { useEffect, useState } from "react";
import { Grid, CircularProgress } from "@material-ui/core";
import Banner from "components/banner/Banner";
import NewsSection from "./news/newsSection";
import DonorsSection from "./donors/donorSection";
import EventsSection from "./upcomingEvents/upcomingEventsSection";
import SocialMediaSection from "./socialMedia/socialMediaSection";
import { callGetApiWithAuth } from "utils/api";
import { makeStyles } from "@material-ui/styles";
import bannerImage1 from "assets/images/slider-image1.jpg";
import bannerImage2 from "assets/images/slider-image2.jpg";
import bannerImage3 from "assets/images/slider-image3.jpg";
import bannerImage4 from "assets/images/slider-image4.jpg";

export default function DashboardPage() {
  const classes = useStyles();

  const [isLoadingList, setIsLoadingList] = useState(false);
  const [newsData, setNewsData] = useState({});
  const [eventData, setEventData] = useState({});
  const [donorsData, setDonorsData] = useState({});
  const [slides, setSlides] = useState(undefined);

  useEffect(() => {
    loadNews();

    setSlides([
      {
        image: bannerImage1,
        title: "Feeding Children and Combating Food Insecurity",
      },
      {
        image: bannerImage2,
        title: "Fighting HumanTrafficking",
      },
      {
        image: bannerImage3,
        title: "Supporting Veterans",
      },
      {
        image: bannerImage4,
        title: "Protecting the Environment",
      },
    ]);
  }, []);

  const loadNews = () => {
    setIsLoadingList(true);
    callGetApiWithAuth('dashboard/news', onGetNewsData, onFailNewsData)
    callGetApiWithAuth("dashboard/events", onGetEventsData, onFailEventData);
    callGetApiWithAuth(
      "dashboard/top_donors",
      onGetDonorsData,
      onFailDonorsData
    );
  };

  const onGetNewsData = (data) => {
    setIsLoadingList(false);
    setNewsData(data.data.data);
  };
  const onGetEventsData = (data) => {
    setIsLoadingList(false);
    setEventData(data.data.data);
  };
  const onGetDonorsData = (data) => {
    setIsLoadingList(false);
    setDonorsData(data.data.topDonors);
  };

  const onFailNewsData = (errorMessage) => {
    setIsLoadingList(false);
  };
  const onFailEventData = (errorMessage) => {
    setIsLoadingList(false);
  };
  const onFailDonorsData = (errorMessage) => {
    setIsLoadingList(false);
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Banner slides={slides} className={classes.bannerSection} />
        </Grid>
        {!isLoadingList ? (
          <>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                  <NewsSection newsData={newsData} />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <EventsSection eventData={eventData} />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <DonorsSection donorsData={donorsData} />
            </Grid>

            <Grid item xs={12} sm={12}>
              <SocialMediaSection />
            </Grid>
          </>
        ) : (
          <div className={classes.loadingRoot}>
            <CircularProgress size={48} />
          </div>
        )}
      </Grid>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  bannerSection: {
    "& h1": {
      width: "100%",
      "@media (min-width: 500px)": {
        width: 450,
      },
    },
  },
  loadingRoot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // position: 'absolute',
    // left: '10%',
    // top: '10%',
    width: "100%",
    height: "100%",
  },
}));
